import type { ControllerState } from "./sdk/types";

export type TerminalControlAction =
  | "none"
  | "acquire"
  | "acquire_and_flush"
  | "flush";

/** Pure policy for attaching a terminal and claiming only a free/idle lease. */
export function terminalControlAction(
  readOnly: boolean,
  controllerMode: ControllerState["mode"],
  hasPendingInput: boolean,
): TerminalControlAction {
  if (readOnly) return "none";
  if (controllerMode === "owned") return "flush";
  if (controllerMode !== "available") return "none";
  // A live session with no active controller should be immediately usable.
  // The normal acquire path never steals an active lease; the authority
  // returns held-elsewhere and the UI leaves the explicit takeover action.
  return hasPendingInput ? "acquire_and_flush" : "acquire";
}
